import styled, { DefaultTheme } from 'styled-components';
import NooderaButton from 'components/NooderaButton/index';
import { TABLET_SMALLER_WIDTH } from 'commons/constants';

interface FormContainerProps {
  maxWidth?: string;
  customPadding?: string;
  theme: DefaultTheme;
}
interface WrapperProps {
  maxWidth?: string;
  theme: DefaultTheme;
  hide?: boolean;
}

export const FormContainer = styled.form<FormContainerProps>`
  display: flex;
  max-width: ${({ maxWidth }) => maxWidth || '720px'};
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.noodera.spacing.x5};
  padding: ${({ customPadding, theme }) => customPadding || theme.noodera.spacing.x3};

  @media only screen and (max-width: ${TABLET_SMALLER_WIDTH}px) {
    padding: ${({ theme }) => theme.noodera.spacing.x5};
  }
`;

export const Wrapper = styled.div<WrapperProps>`
  display: ${({ hide }) => (hide ? 'none' : 'grid')};
  max-width: ${({ maxWidth }) => maxWidth || '720px'};
  width: 100%;
  gap: ${({ theme }) => theme.noodera.spacing.x5};
`;

export const StyledCheckoutNooderaButton = styled(NooderaButton.CTA)`
  margin-top: ${({ theme }) => theme.noodera.spacing.x3};
`;
